import { XPay } from '@xstak/xpay-element-stage';
import React from 'react';
import { Payment } from '../../pages/Payment';
import './PaymentMethods.css';

const PaymentMethods = ({ loading, merchantSettings, formik, shouldShowXPay, xPay, fromPaymentPage }) => {

    return (
        <div className="payment-methods-container">

            {loading ? (
                <div className="skeleton-container">
                    {/* Skeletons to match card size */}
                    <div className="skeleton-row"></div>
                    <div className="skeleton-row"></div>
                </div>
            ) : merchantSettings?.merchant_integrations?.length > 0 ? (
                <div className="payment-list">
                    {merchantSettings.merchant_integrations.map((method, index) => {
                        const isSelected = formik.values.payment_id === method.random_id;
                        return (
                            <label
                                key={`payment-${index}`}
                                className={`payment-method-card ${isSelected ? 'selected' : ''} ${method.image ? 'has-image' : ''}`}
                                htmlFor={`payment-${method.random_id}`}
                            >
                                <input
                                    type="radio"
                                    id={`payment-${method.random_id}`}
                                    name="payment_id"
                                    value={method.random_id}
                                    checked={isSelected}
                                    onChange={formik.handleChange}
                                />

                                <div className="method-left">
                                    <div className="method-icon-wrapper">
                                        {method.image ? (
                                            <img src={method.image} alt={method.display_name} className="method-logo" />
                                        ) : (
                                            <i className={method.icon || 'fas fa-wallet'}></i>
                                        )}
                                    </div>
                                    <span className="method-name">{method.display_name}</span>
                                </div>

                                <div className="radio-circle">
                                    <i className="fas fa-check radio-check"></i>
                                </div>
                            </label>
                        );
                    })}

                    {shouldShowXPay && xPay && (
                        <div className="xpay-container mt-3">
                            <XPay
                                xpay={{
                                    publishableKey: xPay.api_key,
                                    accountId: xPay.account_id,
                                    hmacSecret: xPay.hmac_secret
                                }}
                            >
                                <Payment
                                    slug={xPay.slug}
                                    orderRef={xPay.order_ref}
                                    instanceId={xPay.instance_id}
                                    fromPaymentPage={fromPaymentPage}
                                    orderDate={xPay.order_date}
                                    orderMessage={xPay.order_message}
                                />
                            </XPay>
                        </div>
                    )}
                </div>
            ) : (
                <div className="no-methods">
                    No payment methods available
                </div>
            )}
        </div>
    );
};

export default PaymentMethods; 